import { useEffect } from "react";

/** 今いくつの面が背後を止めているか。重ねて開く面(お気に入り→詳細など)があるため数える */
let locks = 0;
let restore: (() => void) | null = null;

/**
 * 開いている間、背後の本文をスクロールさせない。
 *
 * 面の中でホイールを回すと、端に達したぶんが背後のページに流れてしまう
 * (暗幕の上で回した場合も同じ)。中身側の `overscroll-contain` だけでは
 * 暗幕の上が塞げないので、開いている間は本文そのものを止める。
 */
export function useScrollLock(): void {
  useEffect(() => {
    if (locks === 0) {
      const root = document.documentElement;
      const previousRoot = root.style.overflow;
      const previousBody = document.body.style.overflow;
      root.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      restore = () => {
        root.style.overflow = previousRoot;
        document.body.style.overflow = previousBody;
      };
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0) {
        restore?.();
        restore = null;
      }
    };
  }, []);
}
